export const defaultStyles = {
  color: "var(--theme-email-h3-color-text)",
  fontFamily: "var(--theme-email-h3-font-family)",
  fontWeight: "var(--theme-email-h3-font-weight)",
  fontSize: "var(--theme-email-h3-font-size)",
  lineHeight: "var(--theme-email-h3-line-height)",
  letterSpacing: "var(--theme-email-h3-letter-spacing)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
